import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ConflictError, AppErrors, NotFoundError, BadRequestError } from '@fitness-force/models';;
import type { CreateResponse, SaleReturnCalculationRequest } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { Observable, catchError, map, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class SalesReturnService {
  private http = inject(HttpClient);
  private router = inject(Router);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  SalesReturnCalculation(tenantId: number, client_id:number, invoiceId: number,data:SaleReturnCalculationRequest):Observable<any> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.SALES_RETURN_CALCULATION
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', client_id.toString())
      .replace('{invoice_id}', invoiceId.toString()), data,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  CreateSalesReturn(tenantId: number, client_id:number, invoiceId: number,data:SaleReturnCalculationRequest):Observable<CreateResponse> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.SALES_RETURN
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', client_id.toString())
      .replace('{invoice_id}', invoiceId.toString()), data,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  VoidSalesReturn(tenantId: number, client_id:number, salesReturnId: number,data:any):Observable<any> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.VOID_SALES_RETURN
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', client_id.toString())
      .replace('{sales_return_id}', salesReturnId.toString()), data,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  
  SendSalesReturnPdf(client_id:number, invoiceId:number, salesReturnId: number, channels:any[]):Observable<any> {
    return this.http.post(`${environment.BASE_URL}/clients/${client_id}/invoices/${invoiceId}/sales_return/${salesReturnId}/pdf_salesreturn_invoice`,channels,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetSalesReturnPrint(client_id:number, invoiceId:number, salesReturnId: number):Observable<any> {
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'text/plain',
    //   })
    // };
    const url= `${environment.BASE_URL}/clients/${client_id}/invoices/${invoiceId}/sales_return/${salesReturnId}/pdf_salesreturn_invoice`;
    return this.http.get(url)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getOpenSalesReturnPDF(uuid:string): Observable<string> {
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'text/plain',
    //   })
    // };
    const url= `${environment.BASE_URL}/open/sales_return/${uuid}/pdf_sales_return`;
    return this.http.get(url, { responseType: 'text',headers: this.httpOptions.headers}).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetAvailableOnlineRefund(tenantId:number, clientId:number, invoiceId: number):Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.INVOICES.GET_AVAILABLE_ONLINE_REFUND
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{invoice_id}', invoiceId.toString());
    return this.http.get(url,{headers: this.httpOptions.headers})
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }



}
